export const getReactSelectMultipleValues = (options = [], values = []) => options.filter((option) => values.includes(option === null || option === void 0 ? void 0 : option.value));
export const getReactSelectValue = (options, value) => options === null || options === void 0 ? void 0 : options.find((option) => (option === null || option === void 0 ? void 0 : option.value) === value);
export var MenuPlacementOptions;
(function (MenuPlacementOptions) {
    MenuPlacementOptions["Auto"] = "auto";
    MenuPlacementOptions["Top"] = "top";
})(MenuPlacementOptions || (MenuPlacementOptions = {}));
export const calculateSelectMenuPlacement = ({ menuSize, options = [], ref, }) => {
    if ((ref === null || ref === void 0 ? void 0 : ref.current) && menuSize) {
        const selectOffsetBottom = ref.current.offsetHeight +
            ref.current.getBoundingClientRect().top +
            window.scrollY;
        if (window.innerHeight - selectOffsetBottom >
            Number.parseInt(`${menuSize}`, 10) ||
            options.length < 5) {
            return MenuPlacementOptions.Auto;
        }
    }
    return MenuPlacementOptions.Top;
};
//# sourceMappingURL=helpers.js.map